var password = document.getElementById("password");
var passwordNew = document.getElementById("password_new");
var passwordImg = document.getElementById("showPassword");
var passwordImgNew = document.getElementById("showPassword_new");

var passwordCurrent = document.getElementById("password_current");
var passwordImgCurrent = document.getElementById("showPassword_current");




var rePassword = document.getElementById("password_confirmation");
var rePasswordImg = document.getElementById("rePassword");
var showpassword = "/img/icon/hide-eye.svg";
var hidepassword = "/img/icon/eye.svg";

$("#showPassword").on("click", () => {
    if (password.type == "text") {
        passwordImg.src = showpassword;
        password.type = "password";
    } else {
        password.type = "text";
        passwordImg.src = hidepassword;
    }
});
$("#showPassword_new").on("click", () => {
    if (passwordNew.type == "text") {
        passwordImgNew.src = showpassword;
        passwordNew.type = "password";
    } else {
        passwordNew.type = "text";
        passwordImgNew.src = hidepassword;
    }
});
$("#showPassword_current").on("click", () => {
    if (passwordCurrent.type == "text") {
        passwordImgCurrent.src = showpassword;
        passwordCurrent.type = "password";
    } else {
        passwordCurrent.type = "text";
        passwordImgCurrent.src = hidepassword;
    }
});

$("#rePassword").on("click", () => {
    if (rePassword.type == "text") {
        rePasswordImg.src = showpassword;
        rePassword.type = "password";
    } else {
        rePassword.type = "text";
        rePasswordImg.src = hidepassword;
    }
});
